import React from 'react'
import styled from 'styled-components'

import woc from '../images/happy-person-raising-one-hand.png'
import man from '../images/man-raising-hand-yellow.png'
import poc from '../images/man-raising-hand.png'
import woman from '../images/woman-raising-hand.png'
import rainbow from '../images/rainbow.png'
import wheelchair from '../images/wheelchair.png'

import { OutboundLink } from 'gatsby-plugin-google-analytics'

import unified from 'unified'
import markdown from 'remark-parse'
import html from 'remark-html'

const Container = styled.div`
  background: ${props => props.color};
`

const Team = ({ company }) => {
  var total = company.Number_of_Team_Members
  var num_women = company.Number_of_Women
  var num_poc = company.Number_of_People_of_Color
  var num_lgbtqia = company.Number_of_LGBTQIA_Individuals
  var num_disabled = company.Number_of_Disabled_Individuals

  if (total) {
    return (
      <div className="text-gray-600 pt-2 flex flex-wrap">
        <span className="mr-4 text-sm p-1">
          <img src={woc} className="h-4" alt="emoji of a woman of color" />
          <img src={man} className="h-4" alt="emoji of a man" />
          {/* <img src={poc} className="h-4" alt="emoji of a person of color" />
          <img src={woman} className="h-4" alt="emoji of a woman" />{' '} */}
          {total} people in tech
        </span>

        <span
          className={
            num_women != null && num_women != 0 ? 'mr-4 text-sm p-1' : 'hidden'
          }
        >
          <img src={woc} className="h-4" alt="emoji of a woman of color" />
          <img src={woman} className="h-4" alt="emoji of a woman" /> {num_women}{' '}
          {num_women == 1 ? "woman" : "women"} in tech
        </span>

        <span
          className={
            num_poc != null && num_poc != 0 ? 'mr-4 text-sm p-1' : 'hidden'
          }
        >
          <img src={woc} className="h-4" alt="emoji of a woman of color" />
          <img
            src={poc}
            className="h-4"
            alt="emoji of a person of color"
          />{' '}
          {num_poc} {num_poc == 1 ? "person" : "people"} of color in tech
        </span>

        <span
          className={
            num_lgbtqia != null && num_lgbtqia != 0
              ? 'mr-4 text-sm p-1'
              : 'hidden'
          }
        >
          <img src={rainbow} className="h-4" alt="emoji of a rainbow" />{' '}
          {num_lgbtqia} LGBTQIA+ folks in tech
        </span>

        <span
          className={
            num_disabled != null && num_disabled != 0
              ? 'mr-4 text-sm p-1'
              : 'hidden'
          }
        >
          <img src={wheelchair} className="h-4" alt="emoji of a wheelchair" />{' '}
          {num_disabled} disabled folks in tech
        </span>
      </div>
    )
  } else {
    return ''
  }
}

const Tagline = ({ company }) => {
  var tagline = company.Tagline
  if (tagline) {
    return tagline.split('\n').map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      )
    })
  } else {
    return ''
  }
}

const Diversity = ({ company }) => {
  var diversity = company.Diversity
  if (diversity) {
    return (
      <div>
        <h3 className="text-teal-500 pt-6 pb-4">
          ON DIVERSITY, EQUITY AND INCLUSION
        </h3>
        <div>
          <div
            id="diversity"
            dangerouslySetInnerHTML={{
              __html: unified()
                .use(markdown)
                .use(html)
                .processSync(diversity),
            }}
          />
        </div>
      </div>
    )
  } else {
    return ''
  }
}

class Company extends React.Component {
  render() {
    var company = this.props.data
    var id = this.props.id
    var logo = company.Logo
    var image = logo[0].thumbnails ? logo[0].thumbnails.large.url : logo[0].url
    var name = company.Name
    var titles = company.Role_Titles
    var job_ids = company.Job_IDs
    var job_urls = company.Job_URLs

    var slug = '/company/' + company.Company_ID

    return (
      <Container className="pb-4 flex w-full">
        <div className="h-full w-full border rounded border-light-grey bg-white shadow-lg ">
          <div className={'w-full flex p-4 bg-gray-100'}>
            <div className="w-24 pr-4 pt-1">
              <img src={image} alt={'Photo of ' + name} className="" />
            </div>
            <div className="w-full">
              <h4 className="text-lg">
                <div className="text-gray-900">
                  {/* <a
                    rel="noopener noreferrer"
                    className="text-black font-bold leading-6"
                    id={id}
                    href={id}
                  > */}
                  {company.Name}
                  {/* </a> */}
                </div>
              </h4>
              {/* <div className="text-gray-600">{name} </div> */}
              <Team company={company} />
            </div>
          </div>
          <div className="h-full w-full flex">
            <div className="p-6 pt-6 pb-6 leading-normal job-details">
              <p
                className={
                  company.Tagline != null
                    ? 'text-gray-600 text-sm mt-1 italic'
                    : 'hidden'
                }
              >
                <Tagline company={company} />
              </p>

              <h3 className="text-teal-500 pt-6 pb-4">
                {company.Name} is hiring for the following roles:
              </h3>
              <ul>
                {titles.map(function(title, index) {
                  return (
                    <li>
                      <a href={job_urls[index]}>{title}</a>
                    </li>
                  )
                })}
              </ul>

              <Diversity company={company} />
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

export default Company
